/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateOnboardingWizardScenarioRequest = {
    email?: string;
    password?: string;
    firstName?: string;
    lastName?: string;
    therapistName?: string;
    plan?: CreateOnboardingWizardScenarioRequest.plan;
    isMultiUserManager?: boolean;
    featurePaymentEnabled?: boolean;
    /**
     * When true, omit therapist payment configuration so the onboarding payments setup step stays incomplete (E2E skip flow).
     */
    omitPaymentConfiguration?: boolean;
    /**
     * When true, enable all therapist feature flags before onboarding so every feature setup step appears in the wizard.
     */
    enableAllOnboardingFeatures?: boolean;
};
export namespace CreateOnboardingWizardScenarioRequest {
    export enum plan {
        FREE = 'free',
        PAID = 'paid',
        MULTI_USER = 'multiUser',
    }
}

